import React, { useEffect } from "react";
import bgImg   from "../Moves/ShadowBallBackground.png";
import ballImg from "../Moves/ShadowBall.png";
import "./ShadowBallAnimation.css";

export default function ShadowBallAnimation({ playerRef, opponentRef, onComplete }) {
  useEffect(() => {
    const playerEl   = playerRef.current;
    const opponentEl = opponentRef.current;
    const container  = playerEl.closest(".battle-container");
    const bg         = container?.querySelector(".battle-bg");
    if (!playerEl || !opponentEl || !container) return;

    // 1) Flash the background
     if (bg) {
     const overlay = document.createElement("div");
     overlay.className = "shadow-bg-overlay";
      overlay.style.backgroundImage = `url(${bgImg})`;
      bg.appendChild(overlay);
      // remove after animation
      setTimeout(() => overlay.remove(), 800);
    }

    // 2) Compute coords
    const pRect = playerEl.getBoundingClientRect();
    const oRect = opponentEl.getBoundingClientRect();
    const cRect = container.getBoundingClientRect();
    const startX = (pRect.left + pRect.width/2) - cRect.left;
    const startY = (pRect.top  + pRect.height/2) - cRect.top;
    const endX   = (oRect.left + oRect.width/2)  - cRect.left;
    const endY   = (oRect.top  + oRect.height/2) - cRect.top;
    const dx = endX - startX, dy = endY - startY;

    // 3) Launch the shadow ball
    const orb = document.createElement("img");
    orb.src       = ballImg;
    orb.className = "shadow-ball";
    orb.style.left = `${startX}px`;
    orb.style.top  = `${startY}px`;
    orb.style.setProperty("--dx", `${dx}px`);
    orb.style.setProperty("--dy", `${dy}px`);
    (bg || container).appendChild(orb);

    orb.addEventListener("animationend", () => {
      orb.remove();

      // 4a) Impact shake + tint
      opponentEl.classList.add("shadow-hit");
      setTimeout(() => opponentEl.classList.remove("shadow-hit"), 400);

      // 4b) Ripple
      const ripple = document.createElement("div");
      ripple.className = "shadow-impact";
      ripple.style.left = `${endX}px`;
      ripple.style.top  = `${endY}px`;
      container.appendChild(ripple);

      setTimeout(() => {
        ripple.remove();
        onComplete();
      }, 600);
    });

    // Cleanup if unmounted early
    return () => {
      orb.remove();
    };
  }, [playerRef, opponentRef, onComplete]);

  return null;
}

ShadowBallAnimation.moveType = "ghost";
